import { useMemo } from "react";
import { availabilityEventsRef } from "../lib/data/availability";
import { useFirestoreCollection } from "./useFirestoreCollection";

/**
 * Subscribes to the user's mirrored Google Calendar events at
 * usersAvailability/{uid}/events/**.
 *
 * Phase 1 reads the full set; Phase 2 will likely add a date-range filter
 * once the volume justifies it.
 */
export function useAvailabilityEvents(uid) {
  const queryRef = useMemo(
    () => (uid ? availabilityEventsRef(uid) : null),
    [uid]
  );
  return useFirestoreCollection(queryRef);
}
